/* unplugin-vue-components disabled */import { render } from "./detail.vue?vue&type=template&id=4784ce67&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=4784ce67&scoped=true&lang=css"
import "./detail.vue?vue&type=style&index=1&id=4784ce67&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4784ce67"]])

export default __exports__